import request from '@/utils/request'

//打包用
// export function loginByUsername(name, passwd, captcha) {
//   return request({
//     url: '/security/login',
//     method: 'get',
//     params: {
//       name,
//       passwd,
//       captcha
//     }
//   })
// }

//晋来办登录用
export function loginByAuthtoken(authtoken) {
  return request({
    url: '/login/jlb/authUserLogin',
    method: 'get',
    params: {
      authtoken
    }
  })
}
//开发用
export function loginByUsername(obj) {
  return request({
    url: '/login/security/login',
    method: 'post',
    data: obj
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'get'
  })
}

export function getUserInfo(token) {
  return request({
    url: '/user/queryBytoken',
    method: 'get',
    params: {
      token
    }
  })
}

export function getUserRole(token) {
  return request({
    url: '/permission/user',
    method: 'get',
    params: {
      token
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js